import { render } from "./TressFrame.vue?vue&type=template&id=3d0d22bd&scoped=true"
const script = {}

import "./TressFrame.vue?vue&type=style&index=0&id=3d0d22bd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d0d22bd"]])

export default __exports__